import { render, staticRenderFns } from "./ViewReference.vue?vue&type=template&id=7da6e6de"
import script from "./ViewReference.vue?vue&type=script&lang=js"
export * from "./ViewReference.vue?vue&type=script&lang=js"
import style0 from "./ViewReference.vue?vue&type=style&index=0&id=7da6e6de&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports